import { CustomToast } from '@src/shared/components/reusables/custom-toast';
import { toast } from 'react-hot-toast';

import type { ComponentProps } from 'react';

export const showToast = ({
  dismissible = true,
  duration = 4000,
  position = 'bottom-left',
  ...props
}: ComponentProps<typeof CustomToast>) =>
  toast(
    (t) => (
      <CustomToast
        {...props}
        t={dismissible ? t : undefined}
      />
    ),
    {
      position,
      duration,
      removeDelay: 800,
      style: { padding: 0, background: 'transparent', boxShadow: 'none' },
    }
  );
